import React from "react";
import Header from "../../components/header/Header.component";
import Footer from "../../components/footer/Footer.component";

import "../top-airlines/top-airlines.style.css";
import BannerSearchForm from "../../components/flight-search-form/BannerSearchForm.component";
import FlightSearchForm from "../../components/flight-search-form/FlightSearchForm.component";

export const Miami = () => {
  return (
    <>
      <div className="home-banner">
        <div className="cm-page-center">
          <div className="search-banner">
            <h1>Let Airefare bring your dream vacation to new heights.</h1>
            <FlightSearchForm />
          </div>
        </div>
      </div>
      <div className="cm-section cm-page-center">
        {/* <BannerSearchForm depVal={data} urlVal={dataToSend} /> */}
        <div className="ryan-air">
          <div className="ryanair-title">
            <h1>Miami</h1>
          </div>
          <div className="ryanair-content">
            <p>
              For your next trip to the Sunshine State, take a flight to the
              Miami International Airport. When you book your Miami flights
              through this Florida airport, you'll have convenient access to the
              city's most well-known attractions because the tarmac is only 8
              miles northwest of downtown Miami.
            </p>
            <p>
              Whenever you fly into this Miami airport, go through the different
              duty-free and gift shops to pick some last-minute trinkets or
              stock up on food and a good book for your journey. Additionally,
              the terminals provide a variety of cafes, restaurants, and bars
              where you may fuel up before your flight. Plus, there are endless
              things to do in Miami. You can Visit Miami Beach and South Beach
              to join the sunbathers on the sand or stroll down Lincoln Road to
              peruse the posh shops, galleries, and cafes. Due to its tropical
              climate, Miami is generally one of the top tourist destinations in
              the country.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
